'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getRelevantQuote = undefined;

var _immutable = require('immutable');

var _HubMap = require('self-service-api/constants/HubMap');

var _HubMap2 = _interopRequireDefault(_HubMap);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getRelevantQuote = exports.getRelevantQuote = function getRelevantQuote(activeQuotes, hub) {
  if (activeQuotes.size < 1) return null;
  var hubMerchIds = (0, _immutable.Set)(_HubMap2.default[hub].merchandise);
  var relevantQuote = activeQuotes.filter(function (quote) {
    var recurringCharges = quote.get('recurringCharges') || (0, _immutable.List)();
    var nonRecurringCharges = quote.get('nonRecurringCharges') || (0, _immutable.List)();
    var relevantRecurringCharge = recurringCharges.find(function (charge) {
      return hubMerchIds.has(charge.get('itemId'));
    });
    var relevantNonRecurringCharge = nonRecurringCharges.find(function (charge) {
      return hubMerchIds.has(charge.get('itemId'));
    });
    return relevantRecurringCharge || relevantNonRecurringCharge;
  }).sortBy(function (quote) {
    return quote.get('id');
  }).last();
  return relevantQuote;
};


//////////////////
// WEBPACK FOOTER
// ./js/utils/getRelevantQuote.js
// module id = 590
// module chunks = 3 4 5